import { render, staticRenderFns } from "./SignatureListDialog.vue?vue&type=template&id=8c4e6c64&"
import script from "./SignatureListDialog.vue?vue&type=script&lang=js&"
export * from "./SignatureListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports